import { Link } from 'react-router-dom';

const MentionsLegales = () => {
  return (
    <div className="max-w-4xl mx-auto">
      <div className="bg-white rounded-lg shadow-sm border p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Mentions légales</h1>
        
        <div className="space-y-8">
          {/* Éditeur */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Éditeur</h2>
            <div className="space-y-2 text-gray-700">
              <p><strong>Nom :</strong> EasyRDV</p>
              <p><strong>Développeur :</strong> Yassine Hamdoune</p>
              <p><strong>Email :</strong> hamdouneyassine.03@gmail.com</p>
              <p><strong>Site web :</strong> https://easyrdv.vercel.app</p>
            </div>
          </section>

          {/* Hébergement */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Hébergement</h2>
            <div className="space-y-2 text-gray-700">
              <p>Ce site est hébergé par des services cloud modernes pour assurer une disponibilité optimale.</p>
              <p><strong>Infrastructure :</strong> Services cloud sécurisés</p>
              <p><strong>Localisation :</strong> Union Européenne</p>
            </div>
          </section>

          {/* Propriété intellectuelle */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Propriété intellectuelle</h2>
            <div className="space-y-2 text-gray-700">
              <p>L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.</p>
              <p>La reproduction de tout ou partie de ce site sur un support électronique quel qu'il soit est formellement interdite sauf autorisation expresse du directeur de la publication.</p>
            </div>
          </section>

          {/* Responsabilité */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Responsabilité</h2>
            <div className="space-y-2 text-gray-700">
              <p>Les informations contenues sur ce site sont aussi précises que possible et le site est périodiquement remis à jour, mais peut toutefois contenir des inexactitudes, des omissions ou des lacunes.</p>
              <p>Si vous constatez une lacune, erreur ou ce qui parait être un dysfonctionnement, merci de bien vouloir le signaler par email à l'adresse contact@easyrdv.com.</p>
            </div>
          </section>

          {/* Liens hypertextes */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Liens hypertextes</h2>
            <div className="space-y-2 text-gray-700">
              <p>Les liens hypertextes mis en place dans le cadre du présent site web en direction d'autres ressources présentes sur le réseau Internet ne sauraient engager la responsabilité d'EasyRDV.</p>
            </div>
          </section>

          {/* Cookies */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Cookies</h2>
            <div className="space-y-2 text-gray-700">
              <p>Le site peut-être amené à vous demander l'acceptation des cookies pour des besoins de statistiques et d'affichage. Un cookie ne nous permet pas de vous identifier ; il sert uniquement à enregistrer des informations relatives à la navigation de votre ordinateur sur notre site.</p>
            </div>
          </section>

          {/* Droit applicable */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Droit applicable</h2>
            <div className="space-y-2 text-gray-700">
              <p>Tout litige en relation avec l'utilisation du site EasyRDV est soumis au droit français. En dehors des cas où la loi ne le permet pas, il est fait attribution exclusive de juridiction aux tribunaux compétents de Paris.</p>
            </div>
          </section>

          {/* Contact */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Contact</h2>
            <div className="space-y-2 text-gray-700">
              <p>Pour toute question concernant ces mentions légales, vous pouvez nous contacter à :</p>
              <p><strong>Email :</strong> hamdouneyassine.03@gmail.com</p>
              <p><strong>Développeur :</strong> Yassine Hamdoune</p>
            </div>
          </section>
        </div>

        {/* Back to home */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <Link 
            to="/" 
            className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium"
          >
            ← Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegales; 